import React from "react";
import { Route, Redirect } from "react-router-dom";
import auth from "../services/Auth";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!auth.isTokenExpired() && auth.isAdmin()) {
          return <Component {...props} />;
        } else {
          auth.logout();
          return (
            <Redirect
              to={{
                pathname: "/",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

export default ProtectedRoute;
